import React from "react";
import styled from "@emotion/styled";
import { ThemeContext, UserContext } from "../../contexts/Context";
import { IoAddOutline, IoRemoveOutline } from "react-icons/io5";
import { readableText } from "../../utils/themeContrast";

const MultiQtyOption = ({ array, lanIndex, isLanReverse, produceArrayStateMulti, produceMinusArray, currencySymbol, displayNetAmount, tax, itemTax }) => {
  const themeContext = React.useContext(ThemeContext);
  const { hidePrice } = React.useContext(UserContext);
  return <>
    {array.map((item, index) => {
      const title = (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse)
        ? item.title : (item.title2 || item.title);
      const quantity = Number(item.qty) || 0;
      const price = (Number(item.addPrice || 0) * (displayNetAmount ? (1 + (tax.taxMode == 0 ? tax.tax : itemTax)) : 1)).toFixed(2);
      return <OptionRow themeContext={themeContext} key={item.itemOptionId || index}>
        {item.itemImage && <OptionImage src={item.itemImage} alt="" />}
        <OptionText>
          <span>{title}</span>
          {!hidePrice && <OptionPrice themeContext={themeContext}>{Number(item.addPrice) ? `+ ${currencySymbol}${price}` : "Free"}</OptionPrice>}
        </OptionText>
        <QuantityControls>
          <QuantityButton type="button" themeContext={themeContext} disabled={quantity <= 0}
            aria-label={`Decrease ${title} quantity`}
            onClick={() => produceMinusArray(array, item.itemOptionId)}>
            <IoRemoveOutline size={16} aria-hidden="true" />
          </QuantityButton>
          <Quantity aria-live="polite" aria-label={`${title} quantity`}>{quantity}</Quantity>
          <QuantityButton type="button" themeContext={themeContext}
            aria-label={`Increase ${title} quantity`}
            onClick={() => produceArrayStateMulti(array, item.itemOptionId)}>
            <IoAddOutline size={16} aria-hidden="true" />
          </QuantityButton>
        </QuantityControls>
      </OptionRow>;
    })}
  </>;
};
export default MultiQtyOption;

const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  width: 100%;
  min-height: 58px;
  padding: 10px 16px;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
  background: ${props => props.themeContext.backgroundColor};
  font-family: ${props => props.themeContext.fontFamily};
`;
const OptionImage = styled.img`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 6px;
`;
const OptionText = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  overflow-wrap: anywhere;
`;
const OptionPrice = styled.span`
  font-size: 12px;
  line-height: 1.3;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.descriptionColor, props.themeContext.primaryColor)};
`;
const QuantityControls = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
`;
const QuantityButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid ${props => props.themeContext.primaryColor};
  border-radius: 50%;
  color: ${props => props.themeContext.primaryColor};
  background: transparent;
  cursor: pointer;
  &:disabled { color: #b8aaa7; background: #faf5f4; border-color: #f7eeec; cursor: default; }
  &:focus-visible { outline: 2px solid ${props => props.themeContext.primaryColor}; outline-offset: 2px; }
`;
const Quantity = styled.span`
  min-width: 16px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`;
